/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Gray_Bear_SpinInputs */

const en_fast_gray_bear_spin = /** @type {(inputs: Fast_Gray_Bear_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disallow comments`)
};

const de_fast_gray_bear_spin = /** @type {(inputs: Fast_Gray_Bear_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare verbieten`)
};

/**
* | output |
* | --- |
* | "Disallow comments" |
*
* @param {Fast_Gray_Bear_SpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_gray_bear_spin = /** @type {((inputs?: Fast_Gray_Bear_SpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Gray_Bear_SpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_gray_bear_spin(inputs)
	return de_fast_gray_bear_spin(inputs)
});